import { TipCell, TipRow, TipTable } from '@/nikeone/NikeOneCommon';
import React from 'react';

const PrematchTipsContainerPending = ({ header = false }) => {
    return (
        <div className="nikeone-match">
            {header ? (
                <div className="nikeone-match-header pending">
                    <div className="header-title">
                        <div className="sport-icon wave-animation" />
                        <div className={'opponents wave-animation'} />
                    </div>
                    <div className={'date wave-animation'} />
                </div>
            ) : null}
            <TipTable>
                <TipRow>
                    <TipCellPending />
                    <TipCellPending />
                    <TipCellPending />
                </TipRow>
                <TipRow>
                    <TipCellPending />
                    <TipCellPending />
                    <TipCellPending />
                </TipRow>
            </TipTable>
        </div>
    );
};

export function TipCellPending() {
    return <TipCell classes="static-pending-bg" />;
}

export default PrematchTipsContainerPending;
